<script setup>
import { userAuthState } from '@/@core/auth'
import { emailValidator, requiredValidator } from '@/@core/utils/validators'
import loginBg from '@images/pages/login-bg.jpg'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import { ref } from 'vue'
import { RouterLink, useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const form = ref({ email: '', employee_code: '' })
const errors = ref({ email: null, employee_code: null })
const loading = ref(false)
const router = useRouter()
const forgotPasswordForm = ref()
const authThemeMask = loginBg
const snackbar = useToast()

const submitForm = () => {
  forgotPasswordForm.value?.validate().then(async ({ valid: isValid }) => {
    if (!isValid)
      return

    const res = await userAuthState().forgotPassword(form.value)
  })
}
</script>

<template>
  <VRow
    no-gutters
    class="auth-wrapper bg-surface"
  >
    <VCol
      md="8"
      class="d-none d-md-flex"
    >
      <div class="position-relative bg-background rounded-lg w-100 ma-8 me-0">
        <VImg
          class="auth-footer-mask"
          :src="authThemeMask"
        />
      </div>
    </VCol>

    <VCol
      cols="12"
      md="4"
      class="auth-card-v2 d-flex align-center justify-center"
    >
      <VCard
        flat
        :max-width="500"
        class="mt-12 mt-sm-0 pa-4"
      >
        <VCardText>
          <VNodeRenderer
            :nodes="themeConfig.app.client.logo"
            class="mb-6"
          />
          <h5 class="text-h5 mb-1">
            Forgot Password? 🔒
          </h5>
          <p class="mb-0">
            Enter your <strong>Employee Code</strong> or <strong>Email</strong> and we'll send you password reset instructions
          </p>
        </VCardText>

        <VCardText>
          <VForm
            ref="forgotPasswordForm"
            @submit.prevent="submitForm"
          >
            <VRow>
              <!-- Employee Code -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.employee_code"
                  label="Employee Code"
                  type="text"
                  placeholder=""
                  :rules="form.email ? [] : [requiredValidator]"
                  :error-messages="errors.employee_code"
                />
              </VCol>
              <VCol
                cols="12"
                class="text-center my-2"
              >
                <span class="text-sm text-disabled">- OR -</span>
              </VCol>
              <!-- email -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.email"
                  label="Email"
                  type="email"
                  placeholder="johndoe@email.com"
                  :rules="form.employee_code ? [] : [requiredValidator, emailValidator]"
                  :error-messages="errors.email"
                />
              </VCol>

              <!-- Reset link button -->
              <VCol cols="12">
                <VBtn
                  block
                  type="submit"
                  :loading="loading"
                >
                  Send Reset Link
                </VBtn>
              </VCol>

              <!-- back to login -->
              <VCol cols="12">
                <RouterLink
                  class="d-flex align-center justify-center"
                  :to="{ path: '/app/login' }"
                >
                  <VIcon
                    icon="tabler-chevron-left"
                    class="flip-in-rtl"
                  />
                  <span>Back to login</span>
                </RouterLink>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
